// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"f3dec7e2","872":"68303346","954":"67e27396"}[chunkId] + ".chunk.js";
};